import cls from "./welcomeHeader.module.scss";
import Link from "next/link";
import { BrandLogo } from "components/icons";
import { useAuth } from "contexts/auth/auth.context";
import useLocale from "hooks/useLocale";
import React from "react";
import ProfileDropdown from "components/profileDropdown/profileDropdown";

export default function WelcomeHeader() {
  const { t } = useLocale();
  const { openAuthModal, isAuthenticated, user } = useAuth();

  return (
    <div className="welcome-container">
      <header className={cls.header}>
        <div className={cls.navItem}>
          <Link href="/" className={cls.brandLogo}>
            <BrandLogo />
          </Link>
        </div>
        <div className={cls.navItem}>
          <div className={cls.actions}>
            <Link href="/about" className={cls.itemLink}>
              {t("about")}
            </Link>
            <Link href="/blog" className={cls.itemLink}>
              {t("blog")}
            </Link>
            <Link href="/careers" className={cls.itemLink}>
              {t("careers")}
            </Link>
          </div>
        </div>
        <div className={cls.navItem}>
          {isAuthenticated ? (
            <ProfileDropdown data={user} />
          ) : (
            <button type="button" onClick={openAuthModal} className={cls.login}>
              {t("login")}
            </button>
          )}
        </div>
      </header>
    </div>
  );
}
